<style>
@import '../custom/css/sobre.css';
</style>

<template>
  <div class="container shadow bg-light rounded py-3 mb-5 mt-3 p-1">
    <div class="row">
      <div class="col-12 font-weight-bold title">Redefinir senha</div>
      <hr />
      <div class="col-md-5">
        <div>
          <img
            class="size-imagem"
            src="https://api.construp.com.br/upload/new-password.png"
            alt=""
          />
        </div>
      </div>
      <div class="col-md-5 background mt-5">
        <p>
          Crie uma senha de no mínimo 6 dígitos. Para ter uma senha mais segura,
          use números, letras maiúsculas e caracteres especiais (Ex: ,\#/*@)
        </p>
        <b-modal
          size="md"
          id="modalPasswrd"
          header-bg-variant="orange"
          header-text-variant="light"
          centered
          hide-footer>
            <div class="modalHeader">
              <header class="text-white text-center fs-30 p-3 ml-3">Senha já recuperada!</header>
            </div>
            <p class="text-center fs-20 mb-5 mt-3 textModal">Caso não consiga acessar, solicite <br> <strong class="text-danger">nova recuperação</strong> de senha.</p>
            <span class="btn btn-warning d-flex justify-content-center fs-20" @click="newPasswrd" style="position:relative; bottom: 50px;"><strong>Nova recuperação</strong></span>
          </b-modal>
        <div class="row">
          <input
            :type="type"
            class="form-control my-3 col-md-10 ml-2 mr-5"
            placeholder="Nova senha"
            v-model="newPassword"
          />
    
            <i
              class="eye-align"
              :class="{
                fas: true,
                'fa-eye': !isShowingPassword,
                'fa-eye-slash': isShowingPassword,
                'c-pointer': true,
                'ml-2': true,
              }"
              @click="togglePassword()"
            ></i>
    
        </div>
        <div class="row">
          <input
            :type="type2"
            class="form-control col-md-10 ml-2 mr-5"
            placeholder="Confirmar nova senha"
            v-model="confirmNewPassword"
          />
      
            <i
              class="eye-align2"
              :class="{
                fas: true,
                'fa-eye': !isShowingPassword2,
                'fa-eye-slash': isShowingPassword2,
                'c-pointer': true,
                'ml-2': true,
              }"
              @click="togglePassword2()"
            ></i>
        </div>

        <button @click="disabledRedefine()" class="btn btn-size btn-style">Recuperar senha</button>
      </div>
    </div>
  </div>
</template>

<script>
import makeToast from '../mixins/makeToast';
export default {
  mixins: [makeToast],
  data() {
    return {
      isShowingPassword: false,
      isShowingPassword2: false,
      passwordValid: false,
      type: 'password',
      type2: 'password',
      newPassword: '',
      confirmNewPassword: '',
      redefine: {
        token: '',
        id: '',
        newPassword: '',
      },
      isValid: false,
    };
  },
  methods: {
    newPasswrd() {
      this.$bvModal.show('rescuePasswrd');
      this.$bvModal.hide('modalPasswrd');
    },

    togglePassword() {
      this.isShowingPassword = !this.isShowingPassword;
      if (this.isShowingPassword) this.type = 'text';
      if (!this.isShowingPassword) this.type = 'password';
    },

    togglePassword2() {
      this.isShowingPassword2 = !this.isShowingPassword2;
      if (this.isShowingPassword2) this.type2 = 'text';
      if (!this.isShowingPassword2) this.type2 = 'password';
    },

    disabledRedefine() {
      if (this.newPassword.length < 6) {
        this.makeToast(
          'Ooops',
          'A senha deve ter no mínimo 6 caracteres',
          'danger'
        );
        return;
      }
      if (this.newPassword != this.confirmNewPassword) {
        this.makeToast('Ooops', 'As senhas não conferem', 'danger');
        return
      }
        this.redefine.id = this.$route.query.id;
        this.redefine.token = this.$route.query.token;
        this.redefine.newPassword = this.newPassword;
        if(this.isValid == true) {
          this.$bvModal.show('modalPasswrd');
        }
        let data = this.redefine
        this.$store
          .dispatch("login/restorePassword", data)
          .then((data) => {
              this.makeToast(
              "Sucesso",
              "Senha alterada com sucesso!",
              "success"
            );
            this.isValid = true;
            this.$bvModal.show('login2');
          })
      }
  },
};
</script>
<style scoped>

.modalHeader {
  margin-left: -3.5%;
  width: 97%;
  margin-top: -17px;
}

.textModal {
  position: relative;
  bottom: 50px;
}

header {
  position: relative;
  bottom: 66px;
}

@media screen and (min-width: 390px) {
  header {
    margin-left: -0.2%;
    width: 100.3%;
  }
}

.title {
  text-align: center;
  font-weight: 100;
  font-size: 40px;
  color: #ED670C;
}
.background {
  background: gainsboro;
  max-width: 320px;
  text-align: start;
  margin: auto;
  border-radius: 15px;
  padding: 20px;
  margin-bottom: 10px;
  max-height: 350px;
}
.size-imagem {
  max-width: 100%;
  max-height: 70%;
  margin-left: 5%;
}
.btn-size,
.btn-size:hover {
  width: 282px;
  background: #ED670C;
  color: white;
  text-align: center;
  margin: auto;
  margin-top: 70px;
}
.eye-align {
  display: inline;
  position: relative;
  bottom: 40px;
  left: 270px;
}
.eye-align2 {
  display: inline;
  position: relative;
  bottom: 25px;
  left: 270px;
}
.btn-style {
  position: relative;
  bottom: 25px;
}
</style>
